function isEditor() {
  return '_wpLoadBlockEditor' in global;
}

export { isEditor };
